import { useWizard } from "react-use-wizard";
import RangeByRegionByFacilityTypeStep from "../../../../../../shared/wizard/steps/rangeByRegionByFacilityTypeStep";
import buySteps from "../buySteps";

interface IWishStep_5 {
  typeIds: number[] | null;
  selectedPolygonIds: number[] | null;
}

const WishStep_5 = ({ typeIds, selectedPolygonIds }: IWishStep_5) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.step_4);
  };

  const handleNextStep = () => {
    goToStep(buySteps.wishesSteps.step_6);
  };

  return (
    <div>
      <RangeByRegionByFacilityTypeStep
        typeIds={typeIds ?? []}
        selectedPolygonIds={selectedPolygonIds ?? []}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
      />
    </div>
  );
};
export default WishStep_5;
